"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tagCatagory = void 0;
var tagCatagory;
(function (tagCatagory) {
    tagCatagory[tagCatagory["property"] = 0] = "property";
    tagCatagory[tagCatagory["precedence"] = 1] = "precedence";
    tagCatagory[tagCatagory["device"] = 2] = "device";
    tagCatagory[tagCatagory["entity"] = 3] = "entity";
    tagCatagory[tagCatagory["user"] = 4] = "user";
    tagCatagory[tagCatagory["programme"] = 5] = "programme";
    tagCatagory[tagCatagory["description"] = 6] = "description";
    tagCatagory[tagCatagory["date"] = 7] = "date";
})(tagCatagory || (exports.tagCatagory = tagCatagory = {}));
